import AdminsStore from './AdminsStore'
import AppStore from './AppStore'
import AuthStore from './AuthStore'
import BanksStore from './BanksStore'
import ReportsStore from './ReportsStore'
import CommonStore from './CommonStore'
import ReferenceBooksStore from './ReferenceBooksStore'
import RolePermissionStore from './AccessControl'
import AppRoleStore from './AppRoleStore'
import PermissionStore from './PermissionStore'
import UsersStore from './UsersStore'
import BankPasswordStore from './BankPasswordStore'
import CriticalSectionStore from './CriticalSectionStore'
import AppConfigStore from './AppConfigStore'

const rootStore = {
  appStore: AppStore.create(),
  authStore: AuthStore.create(),
  adminsStore: AdminsStore.create(),
  banksStore: BanksStore.create(),
  reportsStore: ReportsStore.create(),
  commonStore: CommonStore.create(),
  referenceBooksStore: ReferenceBooksStore.create(),
  rolePermissionStore: RolePermissionStore.create(),
  appRoleStore: AppRoleStore.create(),
  permissionStore: PermissionStore.create(),
  usersStore: UsersStore.create(),
  bankPasswordStore: BankPasswordStore.create(),
  criticalSectionStore: CriticalSectionStore.create(),
  appConfigStore: AppConfigStore.create(),
}

export * from './AppStore'
export * from './AuthStore'
export * from './AdminsStore'
export * from './BanksStore'
export * from './ReportsStore'
export * from './CommonStore'
export * from './ReferenceBooksStore'
export * from './BankPasswordStore'
export * from './CriticalSectionStore'
export * from './AppConfigStore'

export {
  rootStore as stores,
  AppStore,
  AuthStore,
  AdminsStore,
  BanksStore,
  ReportsStore,
  CommonStore,
  ReferenceBooksStore,
  RolePermissionStore,
  AppRoleStore,
  PermissionStore,
  UsersStore,
  BankPasswordStore,
  CriticalSectionStore,
  AppConfigStore,
}
